import React from "react";
import { trackEvent } from "../../services/GoogleAnalytics";
import { usePagesTranslation } from "../locales";
import LandingCrosswordSample from "./LandingCrosswordSample";
import "./landingAppFirst.css";

/**
 * Crossword letter-placement demo. On the crossword library it sits beside About.
 */
export default function LandingCrosswordInputSection() {
    const { t } = usePagesTranslation();

    return (
        <div
            className="pi-xw-demo pi-xw-demo--embedded"
            id="crossword-letter-box"
            aria-labelledby="pi-xw-demo-title"
        >
            <div className="pi-xw-demo__layout">
                <LandingCrosswordSample />
                <div className="pi-xw-demo__copy">
                    <p className="pi-section__kicker">
                        {t("landingApp.xw-demo-kicker", "Crossword")}
                    </p>
                    <h2 className="pi-section__title" id="pi-xw-demo-title">
                        {t("landingApp.xw-demo-title", "Place each letter in the right box")}
                    </h2>
                    <p className="pi-section__subtitle">
                        {t(
                            "landingApp.xw-demo-body",
                            "The 5×5 grid starts empty. Place every letter of HELLO in the right box — when the word is complete, it appears on the grid.",
                        )}
                    </p>
                    <div className="pi-xw-demo__actions">
                        <a
                            className="pi-btn pi-btn--brand"
                            href="#crossword-catalog"
                            onClick={() =>
                                trackEvent("clicked", { name: "CrosswordAboutPlayNow" })
                            }
                        >
                            {t("landing.play-now", "Play Now")}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
